import restService from './rest.service'

async function solicitarAsync(credentials) {
    console.log(credentials);
    const { data } = await restService.postAsync('recuperacao/solicitar', credentials);
    return data;
}

async function recuperarAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/recuperar', credentials);
    return data;
}

async function verificarAsync(token) {
    const { data } = await restService.postAsync('recuperacao/verificar', { token });
    return data;
}

async function medicoRegistroAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/medicoRegistro', credentials);
    return data;
}

export default { solicitarAsync, recuperarAsync, verificarAsync, medicoRegistroAsync }